export default __webpack_public_path__ + "static/media/category-banner-Program.ee89888f.jpg";